<script setup lang="ts">
import FadeTransition from '../transitions/FadeTransition.vue'

defineOptions({ inheritAttrs: false })
</script>

<template>
  <FadeTransition appear>
    <div class="relative rounded-xl overflow-hidden bg-gray-200 dark:bg-gray-800" v-bind="$attrs">
      <div
        class="absolute inset-0 animate-shimmer bg-linear-to-r from-gray-200 via-gray-100/90 to-gray-200 dark:from-gray-500 dark:via-gray-400/50 dark:to-gray-500 bg-size-[200%_100%]"
      ></div>
    </div>
  </FadeTransition>
</template>
